<template>
    <div class="common-module-page">
        <div class="page">
            <CommonTitle :title="modelTitle" :page-index="filterData.pageIndex" :page-size="filterData.pageSize" :total="total" @changePage="changePage"/>
            <ul class="excellent-lesson" v-if="list.length" v-loading="loading">
                <li class="excellent-lesson-item" v-for="item in list" :key="item.id" @click="toDetail(item.id)">
                    <div class="list-item link" v-link="linkUrl(item.id)">
                        <div class="list-item-img">
                            <LazyImage :src="item.cover" className="img" />
                            <img class="play-icon" src="~@/assets/img/home/play.png" alt="">
                        </div>
                        <div class="list-item-content">
                            <div class="title" :title="item.title">
                                {{ item.title }}
                            </div>
                            <div class="course-category">
                                <div class="category">{{item.classifyList&&item.classifyList.length&&item.classifyList[0].name}}</div>
                            </div>
                            <div class="teacher-info">
                                <template v-if="item?.lecturerList?.length">
                                    <div class="teacher-label">主讲人：</div>
                                    <div class="teacher-name">{{item.lecturerList[0].name.length > 4 ? (item.lecturerList[0].name.slice(0, 4) + '...') : item.lecturerList[0].name}}</div>
                                    <div class="teacher-school text-overflow"><span class="name-seperator">·</span>{{item.lecturerList[0].workPlace}}</div>
                                </template>
                            </div>
                            <div class="course-info flex-between">
                                <div>{{item.buyUserCount || 0}}人学习</div>
                                <div>{{item.classHour || 0}}学时</div>
                            </div>
                            
                            
                        </div>
                    </div>
                </li>
            </ul>
            <BigNoData v-else class="no-data" url="no-lesson.png" info="暂无网络课程" />
        </div>
    </div>
</template>
<script setup>
import CommonTitle from '@/components/home-common-title/common-index.vue'
import BigNoData from '@/components/no-data.vue'
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex'
import dayjs from 'dayjs';
import { pageJump } from '@/global/location-transfer'
import { jumpHref } from '@/router/jumpHref.js';

const props = defineProps({
    modelTitle: {
        type: String,
        default: ''
    }
})


const store = useStore()

let total = ref(0);
const list = ref([]);

const loading = ref(false);
let filterData = ref({
    pageIndex: 1,
    pageSize: 4,
    bizScene: 'mooc',
    orderType: 'hot', // 排序方式 new-最新 hot-最热 audit-审核状态 recommend-推荐值 keyword-关键字
    queryScope: 'dtBrand',
    showCourseData: 1
});

function getList() {
    loading.value = true
    G_transmit('getFrontMoocList', {
        name: 'getFrontMoocList',
        data: {
            ...filterData.value
        },
        message: false
    }).then(({ data, status: { code, message } }) => {
        if(code === 200){
            list.value = data && data.rows || [];
            total.value = data.total;
        }
        loading.value = false;
    }).catch(err => {
        console.log('error', err)
        loading.value = false;
    })
}
const changePage = (pageIndex) => {
    console.log('pageIndex1', pageIndex)
    filterData.value.pageIndex = pageIndex
    getList();
}


// 跳转慕课详情
function toDetail(id) {
    pageJump(jumpHref.mooc.detail(id), true);
}

function linkUrl(id){
    return {
        url: jumpHref.mooc.detail(id),
        className: 'link-item'
    }
}

onMounted(() => {
     getList()
})

</script>

<style lang="scss" scoped>
.common-module-page {
    // width: 100vw;
    background: #FFFFFF;
    padding-bottom: 40px;
    .page {
        width: 1200px;
        margin: 0 auto;
    }
}
.excellent-lesson {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    border-radius: 4px;
}

.excellent-lesson-item {
    box-sizing: border-box;
    width: 285px;
    // margin-top: 20px;
    margin-right: 20px;
    cursor: pointer;

    &:hover {
         box-shadow: 0px 1px 12px 0px rgba(0,0,0,0.1500);
         .list-item-content {
            border: none;
         }
    }

    &:nth-child(n+4) {
        margin-right: 0;
    }

    .list-item-img {
        width: 100%;
        height: 160px;
        position: relative;
        .img {
            width: 100%;
            height: 100%;
            border-radius: 4px 4px 0px 0px;
        }
        .play-icon {
            width: 44px;
            height: 44px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -22px;
            margin-left: -22px;
            z-index: 1;
        }
    }

    .list-item-content {
        box-sizing: border-box;
        position: relative;
        padding: 12px 16px 16px;
        width: 100%;
        border-radius: 0px 0px 4px 4px;
        border-left: 1px solid #E4E9EE;
        border-right: 1px solid #E4E9EE;
        border-bottom: 1px solid #E4E9EE;
        .title {
            height: 48px;
            font-size: 16px;
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: bold;
            color: #222222;
            line-height: 24px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
        .teacher-info {
            margin-top: 8px;
            display: flex;
            font-size: 14px;
            color: #222222;
            line-height: 19px;
            height: 19px;
            .teacher-label {
                color: #666666;
            }
            .teacher-school {
                width: 0;
                flex: 1;
            }
        }
        .course-info {
            font-size: 14px;
            color: #999999;
            line-height: 19px;
            margin-top: 16px;
        }
        .course-category {
            margin-top: 8px;
            .category {
                display: inline-flex;
                height: 24px;
                background: #F3F6FA;
                border-radius: 2px;
                border: 1px solid #D8DDE6;
                padding: 0 7px;
                font-size: 14px;
                color: #586C80;
                line-height: 24px;
                align-items: center;
            }
        }
        
    }
}
:deep(.link-item){
    width:100%;
    .list-item-link{
        display: flex;
        align-items: center;
    }
}
.no-data {
    margin-top: 50px;
}
.name-seperator {
    margin-left: 3px;
    margin-right: 3px;
}
</style>